import { requestData } from "./utils";

interface CreateBlacklistSenderRequest {
  blacklisted_sender_address: {
    country_code: string;
    sender_address: string;
    product: string;
    type: string;
  };
}

const apiPath = "/blacklist";

export default class BlacklistClient {
  getBlacklistEntries(query) {
    return requestData("GET", apiPath, query);
  }
  createBlacklistedSender(request: CreateBlacklistSenderRequest) {
    return requestData("POST", apiPath, request);
  }
  activateBlacklistedSender(
    product: string,
    country_code: string,
    sender_address: string,
  ) {
    return requestData(
      "POST",
      `${apiPath}/activate?product=${product}&country=${country_code}&sender_address=${sender_address}`,
    );
  }
  deleteBlacklistedSender(
    product: string,
    country_code: string,
    sender_address: string,
  ) {
    return requestData(
      "DELETE",
      `${apiPath}?product=${product}&country=${country_code}&sender_address=${sender_address}`,
    );
  }
}
